<div>
  <div class="mb-[30px]" *ngIf="detail?.show_inquiry_message">
    <nz-alert [nzMessage]="msg">
      <ng-template #msg> {{ detail?.send_to }}: {{ detail?.inquiry_message }} </ng-template>
    </nz-alert>
  </div>

  <div class="v4-layout-form v4-layout-form-vertical" [formGroup]="form">
    <div class="v4-layout-field" *ngIf="detail?.match_type === 'ai_recognition'">
      <div class="v4-layout-field-label">
        {{ "automation-edit_message_html_匹配到问题" | translate }}
        <!-- Question detected -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <nz-select
            formControlName="question_id"
            class="w-full"
            nzSize="large"
            [nzOptions]="optionsOfQuestion"></nz-select>
        </div>
      </div>
    </div>

    <div class="v4-layout-field" *ngIf="detail?.match_type === 'keyword_matching'">
      <div class="v4-layout-field-label">
        {{ "automation-edit_message_html_匹配到关键词" | translate }}
        <!-- Keywords matched -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <input formControlName="keywords" type="text" nz-input nzSize="large" />
        </div>
      </div>
    </div>

    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        {{ "automation-edit_message_html_信息发送给" | translate }}
        <!-- Message will be sent to  -->
        <span class="text-primary font-medium cursor-pointer">{{ detail?.send_to }}</span>
        {{ "automation-edit_message_html_在" | translate }}
        <!-- at -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <div class="w-1/2 pr-2">
            <nz-date-picker
              [nzFormat]="angularDateFormat"
              formControlName="plan_date"
              class="w-full"
              nzSize="large"></nz-date-picker>
          </div>
          <div class="w-1/2 pl-2">
            <nz-time-picker
              formControlName="plan_time"
              class="w-full"
              nzSize="large"
              [nzFormat]="timeFormat"></nz-time-picker>
          </div>
        </div>
      </div>
    </div>

    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        {{ "automation-edit_message_html_内容" | translate }}
        <!-- Content -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row relative" hostDragFileContainer (onDropped)="onUploadFiles($event)">
          <textarea
            formControlName="content"
            nz-input
            rows="8"
            [ngClass]="{
              'pb-[80px]': contentImage?.small_url,
              'pb-[45px]': !contentImage
            }"></textarea>

          <div class="absolute bottom-[1px] left-[10px] right-[20px] py-[10px] bg-white">
            <div class="relative w-[50px] h-[35px] mb-[10px]" *ngIf="contentImage?.small_url as smallUrl">
              <img
                [hostImgPreview]="contentImage.large_url"
                [src]="contentImage?.small_url"
                class="w-full h-full rounded-[4px] cursor-pointer"
                alt="" />
              <span
                class="absolute -right-[6px] -top-[6px] text-[13px] cursor-pointer"
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                (click)="contentImage = null"></span>
            </div>
            <div class="flex flex-row items-center">
              <v4-custom-upload class="mr-[10px]" (onFilesSelected)="onUploadFiles($event)">
                <img
                  class="w-[20px] h-[20px] cursor-pointer"
                  src="/assets/v4/icon-img.svg"
                  alt="Attach a image"
                  title="Attach a image" />
              </v4-custom-upload>
            </div>
          </div>
        </div>
        <div class="v4-layout-field-extra">
          <div class="w-[150px]">
            <host-quick-msg-picker (onSelect)="onSelectQuickMsg($event)"></host-quick-msg-picker>
          </div>
          <!-- <nz-select></nz-select> -->
        </div>
      </div>
    </div>
  </div>

  <div class="footer flex flex-row items-center justify-between">
    <div>
      <a nz-button nzType="link" nzDanger (click)="onRemove()">
        {{ "automation-edit_message_html_移除" | translate }}
        <!-- Remove -->
      </a>

      <a class="ml-2" nz-button nzType="link" (click)="onClickEdit()">{{
        "automation-edit_message_html_编辑规则" | translate
      }}</a>
    </div>
    <div class="ml-auto">
      <button class="mr-3" nz-button nzSize="large" (click)="onExecuteImmediately()">
        {{ "automation-edit_message_html_立即发送" | translate }}
        <!-- Send now -->
      </button>
      <button nz-button nzType="primary" nzSize="large" (click)="onSave()">
        {{ "word.save" | translate }}
        <!-- Save -->
      </button>
    </div>
  </div>
</div>
